import * as React from 'react';
import { DEFAULT_JOURNEY_ID } from '../../constants';
import SettingsContainer from '../../containers/settings';
import {
    Layer,
    Button, ButtonType,
    TextField,
    Spinner, SpinnerType,
    Checkbox,
    IconButton
} from 'office-ui-fabric-react';

interface IProps {
    journeyTitle: string;
    journeyId: string;
    saving: boolean;
    isSharedJourney: boolean;
    isTriageJourney: boolean;
    isPageJourney: boolean;
    hideSteps: boolean;
    portalAuthenticationLevel?: number;
    portaltimeforcompletion?: string;
    journeyComponentCount: number;
    updateJourneyTitle: (value: string) => void;
    saveJourney: () => void;
    saveJourneyAs: () => void;
    publishJourney: () => void;
    journeyTitleErrorMessage: (value: string) => string;
    validateTools: () => boolean;
    copy: (e) => void;
    settings: (e) => void;
};

export class Tools extends React.Component<IProps, any> {

    constructor(props: any) {
        super(props);
    }

    public render() {

        let {
            journeyTitle, journeyId, saving, updateJourneyTitle, saveJourney, publishJourney, saveJourneyAs,
            journeyComponentCount, journeyTitleErrorMessage, validateTools, copy, isSharedJourney, portalAuthenticationLevel, portaltimeforcompletion, settings, isTriageJourney, isPageJourney
        } = this.props;

        return <Layer>
            <div className="tools ovh-tool ms-u-slideDownIn20 anim-1">

                <div className="left ms-u-slideRightIn40 anim-1 anim-delay-05">
                    <Button buttonType={ButtonType.primary} onClick={saveJourney} disabled={!validateTools() || this.props.saving}>
                        <i className="ms-Icon ms-Icon--Save" aria-hidden="true"></i>
                        Save
                    </Button>
                    <Button buttonType={ButtonType.primary} onClick={saveJourneyAs} disabled={!validateTools() || this.props.saving}>
                        <i className="ms-Icon ms-Icon--SaveAs" aria-hidden="true"></i>
                        Save As
                    </Button>
                    <TextField label="Title:" className="journey-title horizontal-label" value={journeyTitle} required={true}
                        onChanged={updateJourneyTitle}
                        onGetErrorMessage={journeyTitleErrorMessage} />

                    {isSharedJourney ? <i> This is a Shared Journey</i> : null}
                    {isTriageJourney ? <i> This is a Triage Journey</i> : null}
                    {isPageJourney ? <i> This is a Page Journey</i> : null}

                </div>

                {settings && <div className="right  ms-u-slideLeftIn40 anim-1 anim-delay-05">
                    <IconButton buttonType={ButtonType.icon} icon="Settings" onClick={settings} disabled={!validateTools()} />
                </div>}

                {journeyId && journeyId !== DEFAULT_JOURNEY_ID ?
                    <div className="right ms-u-slideLeftIn40 anim-1 anim-delay-05">
                        <TextField label="Journey ID:" className="horizontal-label" data-input-id="journeyId" value={journeyId} readOnly={true} />
                        <Button buttonType={ButtonType.normal} className="copy-button" icon="Copy" onClick={copy} title="Copy to clipboard" />
                    </div> : null
                }
                {saving && <div>
                    <Spinner className="tools-loader right" type={SpinnerType.normal} label="Saving and publishing journey..." />
                    <IconButton buttonType={ButtonType.icon} icon="Info" className="tools-loader right" title={"Saving the journey could take a few minutes. You can continue to work on the journey while the save is in progress."} />
                </div>
                }


            </div>
        </Layer>;

    }

}   


// WEBPACK FOOTER //
// ./source/ts/components/tools/tools.tsx